export const notSendGift = [
    {
        id: 1,
        value: 'Thời gian trao thưởng:  Từ 3/11/2025 - 13/11/2025'
    },
    {
        id: 2,
        value: 'Hình thức trao thưởng: Trung tâm IELTS MENTOR sẽ liên hệ & gửi quà về tận nhà cho khách hàng.'
    },
    {
        id: 3,
        value: 'Trường hợp sau thời gian trao thưởng, khách hàng vẫn chưa nhận được quà vui lòng liên hệ trung tâm qua hotline 19004455 để được hỗ trợ'
    }
]

export const noteSpin = [
    {
        id: 1,
        value: 'Toàn bộ quà tặng không có giá trị quy đổi ra tiền mặt'
    },
    {
        id: 2,
        value: 'Sau 3 tháng kể từ ngày 31/10/2025, trung tâm liên hệ khách hàng nhận quà không được, trung tâm không liên hệ được khách hàng để gửi quà tặng thì quà tặng sẽ bị huỷ.'
    },
]